import React from "react";
import { vars } from "./story";
import "./story.css";

// Faint dots that fall slowly behind a tour picture, each on its own clock.
const DROPS = [
  { x: 28, y: 30, delay: 0, dur: 4.2 },
  { x: 74, y: 110, delay: 1.9, dur: 4.8 },
  { x: 131, y: 64, delay: 0.8, dur: 4.4 },
  { x: 188, y: 128, delay: 3.1, dur: 5 },
  { x: 236, y: 22, delay: 1.3, dur: 4 },
  { x: 291, y: 90, delay: 2.6, dur: 4.6 },
];

export function Drizzle(): React.JSX.Element {
  return (
    <g aria-hidden="true">
      {DROPS.map(({ x, y, delay, dur }) => (
        <circle
          key={x}
          className="og-drizzle"
          style={vars({ "--og-delay": `${delay}s`, "--og-dur": `${dur}s` })}
          cx={x}
          cy={y}
          r="1.2"
          fill="var(--color-accent)"
        />
      ))}
    </g>
  );
}
